import React from 'react';

import { Container } from '../../components/Container/Container';
import {
  TERMS_OF_SERVICE,
  LATEST_TERMS_OF_SERVICE,
  LATEST_PRIVACY_POLICY,
  PRIVACY_POLICIES,
} from '../../constants/policies/policies';
import { MetaTags } from '../../components/MetaTags/MetaTags';

interface IProps {
  type: 'privacy' | 'tos';
  /* E.g. de, en, es */
  language?: string;
  version?: string;
  canonical?: string;
}

const Policy = ({ type, language = 'en', version, canonical }: IProps) => {
  const defaultVersion = type === 'privacy' ? LATEST_PRIVACY_POLICY : LATEST_TERMS_OF_SERVICE;
  const policies = type === 'privacy' ? PRIVACY_POLICIES : TERMS_OF_SERVICE;
  const policy = policies.find(p => p.version === (version ?? defaultVersion));
  if (!policy) {
    throw new Error('Could not find the version of the terms of service.');
  }
  if (!policy.content[language]) {
    throw new Error(
      'Could not find the version of the terms of service for the requested language.',
    );
  }
  const Component = policy.content[language];

  return (
    <Container>
      <MetaTags
        title={`Fishbrain - ${type === 'tos' ? 'Terms of service' : 'Privacy policy'}`}
        description={`version: ${version ?? defaultVersion}, language: ${language}`}
        link={canonical}
      />
      <Component appView={false} />
    </Container>
  );
};

// Default export to allow for the way we render the most recent policies

export default Policy;
